import React, {useState, useEffect} from 'react';
import {Grid, Card, CardHeader, CardContent, Tabs, Tab} from '@material-ui/core';
import Perfil from '../pages/Tabnations/Perfil';
import Permissoes from '../pages/Tabnations/Permissoes';
import AtividadesRecentes from "./Tabnations/AtividadesRecentes";
import axios from "../api";

const Main = ({children}) => {
    const [name, setName] = useState('');
    const [value, setValue] = useState(0);
    const [activeTab, setActiveTab] = useState(0);

    const handleChangeTab = (event, newValue) => {
        setValue(newValue);
        setActiveTab(newValue);
    };
    //pega o me
    useEffect(() => {
        async function loadUser() {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get("me", { headers: { Authorization: `Bearer ${token}` } });
                setName(response.data);
            } catch (error) {
                console.log(error);
            }
        }

        loadUser();
    }, []);

    return (
        <main style={{marginLeft: "250px", padding: "20px",}}>
            {children}
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Card style={{height: '90vh', overflow: "auto"}}>
                        <CardContent className={"card-triagem"}>
                            <Grid
                                container
                                spacing={3}
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "baseline",
                                }}
                            >
                                <Grid item>
                                    <CardHeader title="Configurações"/>
                                </Grid>
                            </Grid>
                            <div>
                                <Tabs
                                    value={value}
                                    onChange={handleChangeTab}
                                    style={{
                                        backgroundColor: "rgba(255,255,255,0.5)",
                                    }}
                                >
                                    <Tab
                                        label="Meu Perfil"
                                        style={{
                                            color: activeTab === 0 ? "rgba(0,0,0,0.9)" : "black",
                                            backgroundColor:
                                                activeTab === 0
                                                    ? "#f1f4ff"
                                                    : "rgba(0,0,0,0)",
                                        }}
                                    />


                                    <Tab
                                        label="Atividades recentes"
                                        style={{
                                            color: activeTab === 3 ? "#000000" : "black",
                                            backgroundColor:
                                                activeTab === 3
                                                    ? "#f1f4ff"
                                                    : "rgba(0,0,0,0)",
                                        }}
                                    />
                                    <Tab
                                        label="Permissões"
                                        style={{
                                            color: activeTab === 1 ? "#030303" : "black",
                                            backgroundColor:
                                                activeTab === 1
                                                    ? "#f1f4ff"
                                                    : "rgba(0,0,0,0)",
                                        }}
                                    />
                                </Tabs>
                                {activeTab === 0 && <Perfil user={name} />}
                                {activeTab === 1 && <AtividadesRecentes/>}
                                {activeTab === 2 && <Permissoes/>}
                            </div>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </main>
    );
};

export default Main;
